import mutations from './mutations'
// import { VUEXFIRE_SET_VALUE, VUEXFIRE_ARRAY_ADD, VUEXFIRE_ARRAY_REMOVE } from './types'

export const genericStoreMutations = {}

Object.keys(mutations).forEach(type => {
  // genericStoreMutations[type] = (_, context) => {
  //   mutations[type](context.state, context)
  // }
  genericStoreMutations[type] = (state, payload) => {
    // console.log("MUTATION:", state, payload);
    mutations[type](state, payload)
  }
})
